import { render, staticRenderFns } from "./tableTd.vue?vue&type=template&id=673586a0&scoped=true&"
import script from "./tableTd.vue?vue&type=script&lang=js&"
export * from "./tableTd.vue?vue&type=script&lang=js&"
import style0 from "./tableTd.vue?vue&type=style&index=0&id=673586a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673586a0",
  null
  
)

export default component.exports